import { Injectable, Optional, Inject } from '@angular/core';
import { GenericTranslationService } from '../../services/generic-translation.service';
import {
  ComponentConfig,
  createComponentConfigToken,
  createConfigProvider,
} from '../../services/translation-config.helper';
import { GenericTableListTranslations, GenericTableListTranslationInput } from './generic-table-list-translations.interface';
import { DEFAULT_GENERIC_TABLE_LIST_TRANSLATIONS } from './generic-table-list-translations.defaults';
import { GERMAN_GENERIC_TABLE_LIST_TRANSLATIONS } from './generic-table-list-translations.de';

export interface GenericTableListConfig extends ComponentConfig<GenericTableListTranslations> {}

export const GENERIC_TABLE_LIST_CONFIG = createComponentConfigToken<GenericTableListTranslations>('GENERIC_TABLE_LIST_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class GenericTableListTranslationService extends GenericTranslationService<GenericTableListTranslations> {
  constructor(@Optional() @Inject(GENERIC_TABLE_LIST_CONFIG) config?: GenericTableListConfig) {
    super(DEFAULT_GENERIC_TABLE_LIST_TRANSLATIONS);

    this.registerLanguage('de', GERMAN_GENERIC_TABLE_LIST_TRANSLATIONS);

    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

export const GenericTableListConfigProvider = createConfigProvider<GenericTableListTranslations>(GENERIC_TABLE_LIST_CONFIG);
